var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"container",style:(_vm.cssVars)},[_c('div',{staticClass:"horizontal-placement-fixed-props",attrs:{"id":_vm.id}},[_c('div',{staticClass:"ads-props",attrs:{"id":"M857969ScriptRootC1408001"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }